module.exports = __webpack_public_path__ + "img/bg-contacts.ebd70902.svg";